import { render, staticRenderFns } from "./PoemOpened.vue?vue&type=template&id=e05118fa&scoped=true&"
import script from "./PoemOpened.vue?vue&type=script&lang=js&"
export * from "./PoemOpened.vue?vue&type=script&lang=js&"
import style0 from "./PoemOpened.vue?vue&type=style&index=0&id=e05118fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05118fa",
  null
  
)

export default component.exports